import _ from 'lodash';
import helpers from '../../commonFunction.js';
export default {

    UPDATE_LIST(state, {list, modelName, filterHashed, scopes }) {
        if(list.length === 0) return;
        let stored = state.modelsLoadedWithNsLoader[modelName][filterHashed][scopes];
        let itemsToMutate = helpers.UPDATE_LIST(stored, list);
        if(itemsToMutate.error){
            throw new Error(itemsToMutate.error);
        }
        if (_.isEmpty(stored)) {
            state.modelsLoadedWithNsLoader[modelName][filterHashed][scopes] = itemsToMutate.state;
            state.modelsLoadedWithNsLoader[`${modelName}List`][filterHashed][scopes] = itemsToMutate.list;
        }else{
            for (let item of itemsToMutate.itemsToAdd) {
                this.commit(
                    'nsLoaderStore/ADD_ITEM',
                    {
                        modelName: modelName,
                        item: item,
                        filterHashed,
                        scopes,
                    });
            }
            for (let item of itemsToMutate.itemsToUpdate) {
                this.commit(
                    'nsLoaderStore/EDIT_ITEM',
                    {
                        modelName: modelName,
                        item: item,
                        filterHashed,
                        scopes,
                    });
            }
        }
    },
    EDIT_ITEM(state, {modelName, item, filterHashed, scopes}) {
        for (let key in item) {
            state.modelsLoadedWithNsLoader[modelName][filterHashed][item.uid][scopes][key] = item[key];
        }
    },
    ADD_ITEM(state, {modelName, item, filterHashed, scopes}) {
        this._vm.$set(state.modelsLoadedWithNsLoader[modelName][filterHashed][scopes], item.uid, item);
        state.modelsLoadedWithNsLoader[`${modelName}List`].push(item.uid);
    },

    DELETE_ITEM(state, {modelName, itemUid, filterHashed, scopes}) {
        let index = state.modelsLoadedWithNsLoader[`${modelName}List`][filterHashed][scopes].findIndex(uid =>{
            return uid == itemUid;
        });
        if(index == -1){
            // console.log(`Cannot remove element from store ${itemUid}, ignored`);
            return;
        }
        state.modelsLoadedWithNsLoader[`${modelName}List`][filterHashed][scopes].splice(index, 1);
        delete state.modelsLoadedWithNsLoader[modelName][filterHashed][scopes][itemUid];
    },
    UPDATE_MODEL_TIMESTAMP(state, {modelName, timestamp, filterHashed, scopes}){
        state.timestampsForModelsdWithNsLoader[modelName][filterHashed][scopes] = timestamp;
    },

    REMOVE_DELETED_MODELS(state, {deletedModelUid, modelName, filterHashed, scopes}){
        if(deletedModelUid instanceof Array){
            let _deletedModelUid = [...new Set(deletedModelUid)];
            for(let modelUid of _deletedModelUid){
                this.commit(
                    'nsLoaderStore/DELETE_ITEM',
                    {
                        modelName: modelName,
                        itemUid: modelUid,
                        filterHashed: filterHashed,
                        scopes: scopes,
                    }
                );
            }
        }
    },

    CREATE_LIST_FOR_NS_LOADER(state, {modelName, filterHashed, scopes}) {
        if(!state.modelsLoadedWithNsLoader.hasOwnProperty(modelName)){
            this._vm.$set(state.modelsLoadedWithNsLoader, modelName, {});
            this._vm.$set(state.modelsLoadedWithNsLoader, `${modelName}List`, {});
            this._vm.$set(state.timestampsForModelsdWithNsLoader, modelName, {});
        }
        if(!state.modelsLoadedWithNsLoader[modelName].hasOwnProperty(filterHashed)){
            this._vm.$set(state.modelsLoadedWithNsLoader[modelName], filterHashed, {});
            this._vm.$set(state.timestampsForModelsdWithNsLoader[modelName], filterHashed, {});
            this._vm.$set(state.modelsLoadedWithNsLoader[`${modelName}List`], filterHashed, []);
        }
        if(!state.modelsLoadedWithNsLoader[modelName][filterHashed].hasOwnProperty(scopes)){
            this._vm.$set(state.modelsLoadedWithNsLoader[modelName][filterHashed], scopes, {});
            this._vm.$set(state.timestampsForModelsdWithNsLoader[modelName][filterHashed], scopes, '0.0');
            this._vm.$set(state.modelsLoadedWithNsLoader[`${modelName}List`][filterHashed], scopes, []);
        }
    },
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/concretejs/store/module-nsloader/mutations.js
// module id = null
// module chunks = 